import { combineReducers } from 'redux';

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer.js"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Auth from "./auth/validate/reducer"

const rootReducer = combineReducers({
  Layout,
  Login,
  Account,
  Profile,
  ForgetPassword,
  Auth,
});

export default rootReducer
